import Navbar from "./Navbar";
import Footer from "./Footer";
import StickyBottomBar from "./StickyBottomBar";
import ContextualPopup from "./ContextualPopup";

export default function Layout({ children }) {
  return (
    <div className="min-h-screen flex flex-col bg-[#FAFAFA]">
      <Navbar />
      <main className="flex-1 pb-28">{children}</main>
      <Footer />
      <StickyBottomBar />
      <ContextualPopup />
    </div>
  );
}
